import CategoryPage from "./CategoryPage";

export default function LiveTVPage() {
  return (
    <CategoryPage
      title="Live TV"
      layout="landscape"
      pick={(c) => ({ streams: c.live.streams, categories: c.live.categories })}
    />
  );
}
